const config = {
    variables: {
      welcome_message: "Welcome to our app!",
      gstPercentage: 0.18,
      platformFeePercentage:0.1,
    }
  };
  
  export default config;
  